import React from "react";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

const ImageLightBox2 = ({ stateImages, stateSelectedIndex, stateTitle, stateShow, fnShow }) => {

  const [data, setData] = React.useState({
    images: [],
    index: 0
  })

  React.useEffect(() => {
    setData(d => ({
      ...d,
      images: Array.isArray(stateImages) && (stateImages.length > 0) ? stateImages : [],
      index: Number(stateSelectedIndex)
    }));
  }, [stateImages, stateSelectedIndex])

  return (
    <>
      {stateShow && (data.images.length > 0) &&
        <Lightbox
          imageTitle={stateTitle + ' ' + String(Number(data.index) + 1) + '/' + String(data.images.length)}
          mainSrc={data.images[Number(data.index)]}

          prevSrc={data.images[(Number(data.index) + data.images.length - 1) % data.images.length]}
          nextSrc={data.images[(Number(data.index) + 1) % data.images.length]}

          onCloseRequest={fnShow}

          onMovePrevRequest={() => setData(d => ({ ...d, index: (Number(d.index) + d.images.length - 1) % d.images.length }))}
          onMoveNextRequest={() => setData(d => ({ ...d, index: (Number(d.index) + 1) % d.images.length }))}
        />
      }
    </>
  )
}

export default ImageLightBox2;